import moment from "moment";

import { MedicalRequestType } from "@/Common/Models/MedicalRequest/Enum/MedicalRequestType";
import { ConsultationRequestPriorityOption, DropDownOption, ExamRequestPriorityOption } from "@/Common/Models/UI/Inputs/DropDownOption";
import { FollowUpResponse } from "./Response/FollowUpResponse";

class FollowUpItem {
    public model: FollowUpResponse;

    constructor(model: FollowUpResponse) {
        this.model = model;
    }

    public getSpeciality(): string {
        if (this.model.Speciality != null)
            return this.model.Speciality;

        return cacheStore.GetString("ExamRequestLabel");
    }

    public getCreationDateAsDigit(): string {
        if (!this.model.CreationDate)
            return "";

        let formattedDate = moment(this.model.CreationDate).format("YYYY-MM-DD");
        return formattedDate.replace(/-/g, "");
    }

    public getPriority(): DropDownOption {
        let followUpType = this.getFollowUpType();
        let priority: DropDownOption;

        switch (followUpType) {
            case MedicalRequestType.ConsultationRequest:
                priority = this.model.PriorityDropdownId
                    ? ConsultationRequestPriorityOption.fromDropDownId(this.model.PriorityDropdownId)
                    : ConsultationRequestPriorityOption.Normal;
                break;
            case MedicalRequestType.LabRequest:
                priority = this.model.PriorityDropdownId
                    ? ExamRequestPriorityOption.fromDropDownId(this.model.PriorityDropdownId)
                    : ExamRequestPriorityOption.Normal;
                break;
        }

        return priority;
    }

    public isUrgent(): boolean {
        let followUpType = this.getFollowUpType();
        let isUrgent = false;

        switch (followUpType) {
            case MedicalRequestType.ConsultationRequest:
                isUrgent = ConsultationRequestPriorityOption.Urgent.model.Id === this.model.PriorityDropdownId;
                break;
            case MedicalRequestType.LabRequest:
                isUrgent = ExamRequestPriorityOption.Urgent.model.Id === this.model.PriorityDropdownId;
                break;
        }

        return isUrgent;
    }

    public getFollowUpType(): MedicalRequestType {
        return this.model.MedicalRequestType;
    }

    public isInvalid(): boolean {
        return this.model.IsInvalid;
    }

    public isVisibleInCPP(): boolean {
        return this.model.IsVisibleInCPP;
    }
}

export { FollowUpItem };
